import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundKeydown = this.keydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  keydown(event) {
    const target = event.target
    if (target.matches('input, textarea, [contenteditable="true"]')) return

    // Require Cmd+Shift+N (Mac) or Ctrl+Shift+N (Win/Linux)
    if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.key === 'n') {
      event.preventDefault()
      this.openNewPostModal()
    }
  }

  openNewPostModal() {
    // Find the new post button and click it
    const newPostButton = document.querySelector('[data-new-post-trigger]')
    if (newPostButton) {
      newPostButton.click()
    }
  }
}
